import React, { Fragment } from "react";
import styled from "styled-components";
import Section from "../../components/Section";

export default ({ selected, max, _next, _prev, dispatch }) => {
  const isSelected = !!selected;

  const handleHome = () => {
    if (!isSelected) return null;

    dispatch({
      type: "ME_RELOAD",
      payload: { selected: null },
    });
  };

  return (
    <TestHeader>
      <ContestantSelector $isSelected={isSelected}>
        <div onClick={handleHome}>Список участников</div>
        {isSelected && (
          <Fragment>
            <span>&#8594;</span>
            <div>
              <p>{selected}</p>
              <p>из</p>
              <p>{max}</p>
            </div>
          </Fragment>
        )}
      </ContestantSelector>
      <div>
        <button onClick={_prev}>&#60;</button>
        <button onClick={_next}>&#62;</button>
      </div>
    </TestHeader>
  );
};

const TestHeader = styled(Section)`
  display: flex;
  justify-content: space-between;
  font-weight: normal;
  font-size: 24px;
  color: #777777;
  margin-top: 30px;

  div button {
    :first-child {
      margin-right: 20px;
    }

    width: 53px;
    height: 48px;
    background: #339760;
    border: 3px solid #339760;
    border-radius: 10px;
    color: #ffffff;
    font-size: 24px;
    line-height: 28px;
  }
`;

const ContestantSelector = styled.div`
  display: flex;
  column-gap: 15px;
  line-height: 1;

  > div {
    display: flex;
    column-gap: 5px;
    transition: color 100ms ease-in-out;

    p {
      margin: 0;
    }

    ${({ $isSelected }) =>
      $isSelected &&
      `
      &:first-child {
      cursor: pointer;

      &:hover {
        color: #000;
      }
    }
    `}
  }
`;
